<template>
    <div>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <div class="row">
            <div class="col-md-12">
                <div class="card   abtg__default-card abtg__default-card-border">
                    <div class="card-head">
                        <header> <span class="small abtg__color">{{ $t('purpose.purpose_title') }}</span>
                        </header>
                    </div>
                    <div class="card-body ">
                        <div class="row" v-if="voteResult === false">
                            <div class="col-lg-7">
                                <div class="alert alert-success">{{$t('purpose.purpose_alert')}}</div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:20px">
                            <div class="col-lg-7">

                                <div v-for="(n, index) in votesListData">
                                    <div class="row">
                                        <div class="col-lg-1">
                                            <div class="abtg__top-ranking"
                                                 v-if="parseInt(n.status) !== 2"
                                            >#{{index + 1}}
                                            </div>
                                        </div>
                                        <div class="col-lg-7">
                                            <div class="abtg__top-proposal">{{n.proposal}}
                                            </div>
                                        </div>
                                        <div class="col-lg-2">{{n.votes}} {{$t('purpose.purpose_voti')}}</div>
                                        <div class="col-lg-2 text-center">
                                            <button
                                                    @click="sendVote({id: n.id})"
                                                    v-if="parseInt(n.status) !== 2"
                                                    class="btn btn-success abtg__btn-star shadow-none">{{$t('purpose.purpose_vota')}}
                                            </button>

                                            <span
                                                    v-if="parseInt(n.status) === 2">
                                            <i class="fas fa-star" style="color:orange"></i><i class="fas fa-star"
                                                                                               style="color:orange"></i><i
                                                    class="fas fa-star" style="color:orange"></i>
                                                <br>
                                                {{$t('purpose.purpose_real')}}
                                               



                                                </span>
                                        </div>

                                    </div>
                                    <hr>
                                </div>

                            </div>
                            <div class="col-lg-5">

                                <div class="row">
                                    <div class="col">
                                        <h4 style="margin-top:-10px">{{$t('purpose.purpose_sub')}}</h4>
                                    </div>
                                </div>
                                <form @submit.prevent="sendProposal" class=" "
                                      style="background-color:#efefef;padding:20px;border: 1px solid #b5b5b5;"
                                      v-if="!hideFormProposal"
                                >
                                    <div class="row">
                                        <div class="col-lg-8">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                <input class="mdl-textfield__input abtg__input" name="price" type="text"
                                                       v-model="singleProposal"
                                                >
                                                <label class="mdl-textfield__label">{{$t('purpose.purpose_desc')}}<span
                                                        class="abtg__asterisk">*</span></label>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                <button type="submit"
                                                        class="btn btn-success abtg__btn-third shadow-none">{{$t('purpose.purpose_invia')}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                                </form>

                                <div class="row" v-if="hideFormProposal">
                                    <div class="alert alert-success">Grazie per aver contribuito. Il team di Real Estate
                                        Pro valuterà la tua proposta e la inserirà nella classifica qui a lato.
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';

    export default {
     data() {
      return {
        lang:'',
      }
    },
        components: {
            NBread
        },
        computed: {
            ...mapState('n_track', ['bread_active', 'bread_list', 'votesListData',
                'hideFormProposal',  'voteResult'
            ]),
            singleProposal: {
                get () {},
                set (value) {
                    this.SET_DATA({name: 'singleProposal', data: value });
                }
            }
        },

        created() {
            this.lang=window.localStorage.getItem("language");
            
            if(this.lang==='es'){
                this.SET_DATA({name: 'bread_active', data: {label: 'Propone tu idea'}});
            }else{
                this.SET_DATA({name: 'bread_active', data: {label: 'Proponi la tua idea'}});
            }
            
            this.votesList();
        },
        methods: {
            ...mapActions('n_track', ['votesList',  'sendVote', 'sendProposal']),
            ...mapMutations('n_track', ['SET_DATA']),
        }
    }
</script>